var _rect, _rect2, _rect3, _text, _text2, _text3, _text4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCmdPrompt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 1,
    fill: "#000",
    stroke: "#808080",
    strokeWidth: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 4,
    fill: "#000080"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 3,
    width: 3,
    height: 2,
    fill: "#c0c0c0",
    rx: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 4,
    y: 13,
    fontFamily: "Courier New, monospace",
    fontSize: 5,
    fill: "#c0c0c0"
  }, "C:\\&gt;_")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 4,
    y: 19,
    fontFamily: "Courier New, monospace",
    fontSize: 4,
    fill: "#c0c0c0"
  }, "Microsoft Windows")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 4,
    y: 24,
    fontFamily: "Courier New, monospace",
    fontSize: 4,
    fill: "#c0c0c0"
  }, "[Version XP]")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 4,
    y: 29,
    fontFamily: "Courier New, monospace",
    fontSize: 5,
    fill: "#00ff00"
  }, "C:\\&gt;\u25A0")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmdPrompt);
export default __webpack_public_path__ + "static/media/cmd-prompt.aed4cce3f0ff7d2f8598db793b16542a.svg";
export { ForwardRef as ReactComponent };